import classNames from 'classnames'
import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { useSwipeable } from 'react-swipeable'

import useSizes from '../../../hooks/useSizes'
import { Prog, ProgPart } from '../../../utils/types'
import usePlaybackPosition from '../../common/PreviewPlayer/usePlaybackPosition'
import Player from '../hooks/player/Player'
import styles from './PartsMenu.module.scss'
import PartsMenuSimpleItem from './PartsMenuItem/PartsMenuSimpleItem'

const PartsSimpleMenu = ({
  parts,
  currentPartId,
  handlePartClick,
  prog,
  player,
}: {
  parts: Array<ProgPart>
  currentPartId: number
  player: Player
  prog: Prog
  handlePartClick: (item: ProgPart) => void
}) => {
  const [mobileModalOpen, setMobileModalOpen] = useState(false)
  const { isMobile } = useSizes()
  const playbackPosition = usePlaybackPosition({ prog, currentPartId, player })
  const [localPosition, setLocalPosition] = useState<number | null>(null)
  const handlers = useSwipeable({
    onSwipedUp: () => {
      setMobileModalOpen(false)
    },
    onSwiping: (e) => {
      console.error(e)
      setLocalPosition(e.deltaY)
    },
    onSwiped: () => {
      setLocalPosition(null)
    },
  })
  const renderList = () => (
    <div className={styles.simpleList}>
      {parts
        .filter((item) => item.chords?.length > 0 || !!item.drums)
        .map((item) => (
          <React.Fragment key={item.id}>
            <PartsMenuSimpleItem
              item={item}
              active={item.id === currentPartId}
              playbackPosition={item.id === currentPartId ? playbackPosition : undefined}
              onClick={() => {
                handlePartClick(item)
                setMobileModalOpen(false)
              }}
            />
          </React.Fragment>
        ))}
    </div>
  )
  if (isMobile) {
    return (
      <>
        <div>
          <PartsMenuSimpleItem
            item={parts.find((p) => p.id === currentPartId) as ProgPart}
            mobileMain
            mobileMainOpened={mobileModalOpen}
            playbackPosition={playbackPosition}
            // onClick={() => setMobileModalOpen(!mobileModalOpen)}
          />
        </div>
        <motion.div
          className={styles.mobilePartsListContainer}
          data-open={mobileModalOpen}
          initial={{
            height: 0,
          }}
          onTouchMove={(e) => e.stopPropagation()}
          transition={{ duration: localPosition ? 0.1 : 0.35, ease: 'easeOut' }}
          animate={{
            height: localPosition ? `calc(70vh + ${localPosition}px` : mobileModalOpen ? '70vh' : 0,
          }}
        >
          <div className={styles.scrollContent} onTouchMove={(e) => e.stopPropagation()}>
            {renderList()}
          </div>
          <div className={styles.mobileControl} {...handlers}>
            <div>
              <div />
            </div>
          </div>
        </motion.div>
      </>
    )
  }
  return (
    <div className={classNames(styles.container, styles.simpleContainer)}>
      <div className={styles.list}>{renderList()}</div>
    </div>
  )
}

export default PartsSimpleMenu
